export class ProblemJsonError extends Error {
    status;
    code;
    problemType;
    constructor(problem) {
        super(problem.detail ?? problem.title);
        this.status = problem.status;
        this.code = problem.code;
        this.problemType = problem.type;
    }
}
const UNKNOWN_PROBLEM = "https://pushback-and-chaos.dev/problems/unknown";
export async function throwIfProblem(response) {
    if (response.ok)
        return;
    const contentType = response.headers.get("content-type") ?? "";
    if (contentType.includes("application/problem+json")) {
        const body = (await response.json());
        throw new ProblemJsonError(body);
    }
    throw new ProblemJsonError({
        type: UNKNOWN_PROBLEM,
        title: response.statusText,
        status: response.status,
        code: "UNKNOWN",
    });
}
/** The type a better-auth refusal is given once read: it is not the api's problem+json, but it is typed the same way. */
export const AUTH_PROBLEM_TYPE = "https://pushback-and-chaos.dev/problems/auth";
/**
 * THE READER FOR /auth/* (2026-10-22). better-auth's answers pass through the
 * api unchanged (apps/api/src/routes/account.ts), so its refusals arrive as
 * `application/json {code, message}`, never problem+json, and the reader
 * above would make every one of them `UNKNOWN` with the HTTP status text as
 * its message, which is empty over HTTP/2. This one keeps better-auth's
 * `code` (EMAIL_NOT_VERIFIED, INVALID_TOKEN, TOKEN_EXPIRED,
 * PASSWORD_TOO_SHORT, INVALID_EMAIL_OR_PASSWORD, ...) and its message. The
 * api's own problem+json still arrives on these routes (its rate limit covers
 * /auth/* too) and is read as above. A refusal with no code (better-auth's
 * own rate limit says only `{message}`) or no readable body is `UNKNOWN`
 * with the status kept. Never a parse error.
 */
export async function throwIfAuthProblem(response) {
    if (response.ok)
        return;
    const contentType = response.headers.get("content-type") ?? "";
    if (contentType.includes("application/problem+json"))
        return throwIfProblem(response);
    const body = contentType.includes("application/json") ? await response.json().catch(() => null) : null;
    const field = (name) => {
        if (body === null || typeof body !== "object")
            return undefined;
        const value = body[name];
        return typeof value === "string" && value.length > 0 ? value : undefined;
    };
    const code = field("code");
    const message = field("message");
    throw new ProblemJsonError({
        type: code === undefined ? UNKNOWN_PROBLEM : AUTH_PROBLEM_TYPE,
        title: response.statusText,
        status: response.status,
        code: code ?? "UNKNOWN",
        ...(message === undefined ? {} : { detail: message }),
    });
}
//# sourceMappingURL=errors.js.map